import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const SideBar = ({ siteTitle }) => (
  <aside>
    <div className="wrapper">
      <h1 style={{ margin: 0 }}>
        <Link
          to="/">
          {siteTitle}
        </Link>
      </h1>
      <p>I am a self-driven full stack developer with more than 5 years of experience. I enjoy learning, and I love music. </p>
      <p>I have a solid foundation with laravel, wordpress, shopify, css, sass, php, sql, html, vuejs, reactjs, jquery, javascript(ES6), and git.</p>
      <footer>
          <ul>
            <li><a href="https://github.com/cwiggan">Git</a></li>
            <li><a href="https://www.linkedin.com/in/cwiggan/">linkedin</a></li>
          </ul>
          © {new Date().getFullYear()}
      </footer>
    </div>
  </aside>
)

SideBar.propTypes = {
  siteTitle: PropTypes.string,
}

SideBar.defaultProps = {
  siteTitle: ``,
}

export default SideBar